import { render, staticRenderFns } from "./Qnacontact.vue?vue&type=template&id=6e7085eb&scoped=true&"
import script from "./Qnacontact.vue?vue&type=script&lang=js&"
export * from "./Qnacontact.vue?vue&type=script&lang=js&"
import style0 from "./Qnacontact.vue?vue&type=style&index=0&id=6e7085eb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7085eb",
  null
  
)

export default component.exports